import React from 'react';
import { Redirect } from 'react-router-dom';

export function RedirectToIndex() {
  return <Redirect to="/" />;
}
